import { useQuery } from '@tanstack/react-query'
import { deviceSqlDatabasesQuery, formatSizeMb, type SqlInstance } from '../api/sqlDatabases'

/**
 * Bazele SQL Server de pe aparat, pe fila Summary: instanta, baza, marimea,
 * starea, modelul de recuperare, ultimul backup complet. Le citeste agentul de
 * Windows o data pe zi, cu contul lui (LocalSystem); o instanta la care n-are
 * login spune asta in loc de lista.
 *
 * Fara SQL Server, fara drept de CMDB sau cu capatul cazut nu se deseneaza
 * nimic.
 */
export function DeviceSqlDatabases({ id }: { id: number }) {
  const { data } = useQuery({ ...deviceSqlDatabasesQuery(id), retry: false })
  const instances = data?.instances ?? []
  if (instances.length === 0) return null

  return (
    <div className="row row-content dv-sql-databases">
      <div className="col-md-12">
        <h4 className="bordered">
          <strong>SQL Server</strong> databases
          {data?.collectedAt && <small className="text-muted"> read {data.collectedAt}</small>}
        </h4>
        <table className="table table-condensed" id="deviceSqlDatabases">
          <thead>
            <tr>
              <th>Instance</th>
              <th>Database</th>
              <th className="text-right">Size</th>
              <th>State</th>
              <th>Recovery</th>
              <th>Last full backup</th>
            </tr>
          </thead>
          <tbody>
            {instances.map((inst) => (
              <InstanceRows key={`${inst.engine}:${inst.name}`} inst={inst} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function InstanceRows({ inst }: { inst: SqlInstance }) {
  const user = inst.databases.filter((d) => !d.system)
  const title = [inst.edition, inst.version].filter((s) => s !== '').join(' ')
  if (user.length === 0) {
    const why = inst.status === 'ok' || inst.status === 'partial' ? 'No user databases' : inst.statusLabel
    return (
      <tr className="dv-sql-instance-only">
        <td title={title}>{inst.name}</td>
        <td colSpan={5} className="text-muted">
          {why}
          {inst.error !== '' && <span title={inst.error}> ({inst.error})</span>}
        </td>
      </tr>
    )
  }
  return (
    <>
      {user.map((d, i) => (
        <tr key={d.name}>
          <td title={title}>{i === 0 ? inst.name : ''}</td>
          <td>{d.name}</td>
          <td className="text-right">{d.sizeMb === null ? '-' : formatSizeMb(d.sizeMb)}</td>
          <td>{d.state}</td>
          <td>{d.recovery}</td>
          <td>
            {d.lastFullBackup !== null ? (
              d.lastFullBackup.slice(0, 16)
            ) : inst.status === 'ok' ? (
              <span className="text-danger">never</span>
            ) : (
              <span className="text-muted" title={inst.statusLabel}>
                not readable
              </span>
            )}
          </td>
        </tr>
      ))}
    </>
  )
}
